import { Role } from "../../types/role";

const KOSun: Role = {
  primary: [
    "Ballannahme",
    "Dribbling",
    "Kopfball",
    "Passen",
    "Technik",
    "Weitschuesse",
    "Antizipation",
    "Entscheidungen",
    "Nervenstaerke",
    "OhneBall",
    "Uebersicht",
    "Antritt",
    "Beweglichkeit",
    "Kraft",
  ],
  secondary: [
    "Abschluss",
    "Einsatzfreude",
    "Teamwork",
    "Ausdauer",
    "Balance",
    "Schnelligkeit",
    "Sprunghoehe",
  ],
  physis: "angriff",
};

const KOSan: Role = {
  primary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Kopfball",
    "Technik",
    "Antizipation",
    "Nervenstaerke",
    "OhneBall",
    "Antritt",
    "Beweglichkeit",
    "Kraft",
  ],
  secondary: [
    "Passen",
    "Weitschuesse",
    "Einsatzfreude",
    "Entscheidungen",
    "Teamwork",
    "Uebersicht",
    "Ausdauer",
    "Balance",
    "Schnelligkeit",
    "Sprunghoehe",
  ],
  physis: "angriff",
};

export const KOS = {
  KOSun,
  KOSan,
};
